<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>Artikelsuche</li>
    </ul>
  </div>

  <ng-select
    [multiple]="true"
    [items]="articleTemplates"
    [bindValue]="'id'"
    [(ngModel)]="selectedArticleTemplateId"
    (ngModelChange)="changeSelectedTemplates()"
    [placeholder]="'Artikelvorlage'"
  >
    <ng-template ng-label-tmp let-item="item">
      {{ item.id }} {{ item.vendor }} {{ item.product_category }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      {{ item.id }} {{ item.vendor }} {{ item.product_category }}
    </ng-template>
  </ng-select>

  <input class="bm-input" [(ngModel)]="searchTerm" placeholder="Suchbegriff" [disabled]="!articlesPresent" />
  @if (!articlesPresent) {
    <button
      class="bm-btn bm-btn-circle bm-tooltip bm-tooltip-left"
      [attr.data-tip]="'Bitte eine Artikelvorlage auswählen um Suche anzuzeigen'"
    >
      <i class="fa fa-info"></i>
    </button>
  }
</div>

<div class="page-content page-frame">
  <ag-grid-angular
    class="ag-theme-quartz h-full"
    [rowData]="articles"
    [columnDefs]="colDefs"
    [pagination]="true"
    [paginationPageSize]="50"
    [localeText]="locale"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [paginationPageSizeSelector]="[50, 100, 300, 1000, 9000]"
  />
</div>
